import React, { PropsWithChildren } from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

const BaseButton = ({
  onClick,
  className,
  children,
}: PropsWithChildren<{
  onClick: () => void;
  className?: string;
}>) => {
  return (
    <div
      onClick={onClick}
      className={twMerge(
        'title-20m cursor-pointer select-none rounded-full px-8 py-3 text-white',
        className
      )}
    >
      {children}
    </div>
  );
};

export default BaseButton;

export interface IButtonProps {
  className?: string;
  onClick: () => void;
}

const PrimaryButton = ({
  onClick,
  className,
  children,
}: PropsWithChildren<IButtonProps>) => {
  return (
    <BaseButton
      onClick={onClick}
      className={twMerge(
        'bg-bk-100 hover:bg-pri-100 active:bg-[#A64600]',
        className
      )}
    >
      {children}
    </BaseButton>
  );
};

const SecondaryButton = ({
  onClick,
  className,
  children,
}: PropsWithChildren<IButtonProps>) => {
  return (
    <BaseButton
      onClick={onClick}
      className={twMerge(
        'bg-sec-100 hover:bg-sec-100 active:bg-[#3A45A8]',
        className
      )}
    >
      {children}
    </BaseButton>
  );
};

export { PrimaryButton, SecondaryButton };
